// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".month_container[data-v-6c420876]{margin:1.5rem 0!important}.middle-hr[data-v-6c420876]{border-color:inherit;border-width:2px 0;border-style:solid;display:flex;justify-content:center;color:#27846d;padding-bottom:.3rem;padding-top:.3rem;font-size:17px}", ""]);
// Exports
module.exports = exports;
